export const concatenateValuesVisitor = (fields, destination) => (args) => {
    if (args.visitable.measures) {
        const allMeasures = args.visitable.measures;
        allMeasures[destination] = fields.map((x) => (allMeasures[x] ?? "")).join("|");
    }
};
